import { EventInput } from '@fullcalendar/core';
import { ExternalCalendarEventExtendedProps } from 'shared/lib/full-calendar';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

export const mapExternalEventToFullCalendarEvent = (
  externalEvent: ExternalCalendarEvent,
): EventInput => ({
  id: externalEvent.id,
  title: externalEvent.title,
  // All-day events carry a `date`; their `end.date` is exclusive — exactly what
  // FullCalendar expects — so a multi-day event spans natively as one bar.
  // Timed events keep their `dateTime`s and FullCalendar slices multi-day ones
  // across the time-grid columns itself.
  allDay: !!externalEvent.start.date && !!externalEvent.end.date,
  start: externalEvent.start.dateTime ?? externalEvent.start.date ?? undefined,
  end: externalEvent.end.dateTime ?? externalEvent.end.date ?? undefined,
  extendedProps: {
    externalId: externalEvent.id,
    url: externalEvent.url,
    color: externalEvent.color,
    name: externalEvent.title,
  } satisfies ExternalCalendarEventExtendedProps,
  editable: false,
});
